// import axios from "axios";
import apiAnimals from "../config/api_animals";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function getAnimalsMeasurements(payload) {
  const { groupId, farmId, search, page, size, sort, signal } = payload;

  const orderS =
    Object.entries(sort).length > 0 && sort.order
      ? sort.order === "descend"
        ? "DESC"
        : sort.order === "ascend"
        ? "ASC"
        : "DESC"
      : "DESC";
  const requestParams = `page=${page > 0 ? page - 1 : 0}&size=${size ?? 10}${
    sort && Object.entries(sort).length > 0 && sort.order
      ? `&sort=${sort.field}&direction=${orderS}`
      : ""
  }${search && search !== "" ? `&search=${search}` : ""}`;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/measurements?${requestParams}`,
    getHeaders(false, signal)
  );
}

export function saveAnimalMeasurement(payload) {
  const { groupId, farmId, body, signal } = payload;

  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/animals/measurements`,
    body,
    getHeaders(false, signal)
  );
}

export function updateAnimalMeasurement(payload) {
  const { groupId, farmId, id, body, signal } = payload;

  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/animals/measurements/${id}`,
    body,
    getHeaders(false, signal)
  );
}

export function deleteAnimalMeasurement(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiAnimals.delete(
    `/bovexo/${groupId}/farms/${farmId}/animals/measurements/${id}`,
    getHeaders(false, signal)
  );
}

export function getLastAnimalMeasurement(payload) {
  const { groupId, farmId, animalId, measurementId, signal } = payload;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/${animalId}/measurements/last?measurementId=${measurementId}`,
    getHeaders(false, signal)
  );
}

export function verifyCanEditAndDeleteMeasurement(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/measurements/${id}/can-edit-delete`,
    getHeaders(false, signal)
  );
}
